import * as Sentry from '@sentry/react';
import { isDev } from './clientService';

export const setUserProperties = (userDetails) => {
  if (isDev()) return;

  if (userDetails?._id) {
    try {
      Sentry.setContext('character', {
        userId: userDetails._id,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email,
      });
      Sentry.setUser({
        userId: userDetails._id,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        email: userDetails.email,
      });
    } catch (e) {
      console.log(e);
    }
  }
};
